import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {sortErrors} from 'notebook/tables/excess/Util';
import {BaseCellError} from 'notebook/tables/TableConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';

import {EvaluatedCellError} from '../excess/Evaluator';

interface Props {
  error: EvaluatedCellError;
  labelClass: string;
  children: JSX.Element;
  placement?: FloatingPlacement;
}

function ErrorTrianglePopover(props: Props): JSX.Element {
  const sortedErrors = sortErrors(props.error);
  const errors: Array<BaseCellError> = Array.isArray(sortedErrors) ? sortedErrors : [sortedErrors];
  return (
    <Popover
      placement={props.placement}
      renderContent={() => (
        <div className={css(styles.container)}>
          {errors.map((error) => {
            const message = error.message;
            const title = error.type;
            const hasMessage = Boolean(message) && message.length > 0;
            return (
              <div key={error.message} className={css(styles.item)}>
                <div
                  className={classNames('label', props.labelClass, {
                    'u-tiny-spacing-right': hasMessage,
                  })}
                >
                  {title}
                </div>

                {hasMessage && message}
              </div>
            );
          })}
        </div>
      )}
    >
      {props.children}
    </Popover>
  );
}
ErrorTrianglePopover.displayName = 'ErrorTrianglePopover';

const styles = StyleSheet.create({
  container: {display: 'flex', flexDirection: 'column', gap: '4px'},
  item: {marginBottom: '4px'},
});

export default ErrorTrianglePopover;
